export default __webpack_public_path__ + "static/media/mobile8.cba190c6.webp";